export { default } from './CGMAuthPopup';
